import i18n from 'i18n-js';

export const ORE_ESPORTS_TEMPLATES_TITLES = {
  CONTROLLER_PS4ORE: 'controller-ps4ore',
  CONTROLLER_PS5ORE: 'controller-ps5ore',
  COUNTDOWN_ORE: 'countdown-ore',
  MEDIALOOP_ORE: 'medialoop-ore',
};

export const ORE_ESPORTS_TEMPLATES_IMAGES = {
  [ORE_ESPORTS_TEMPLATES_TITLES.CONTROLLER_PS4ORE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4ore-1.webp',
  [ORE_ESPORTS_TEMPLATES_TITLES.CONTROLLER_PS5ORE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5ore-1.webp',
  [ORE_ESPORTS_TEMPLATES_TITLES.COUNTDOWN_ORE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-ore-1.webp',
  [ORE_ESPORTS_TEMPLATES_TITLES.MEDIALOOP_ORE]:
    'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-ore-1.webp',
};

export const ORE_ESPORTS_TEMPLATES = {
  ore: [
    {
      category: i18n.t('screens.templates.countdown.title'),
      description: i18n.t('screens.templates.ore.countdown.description'),
      shortDescription: i18n.t(
        'screens.templates.ore.countdown.shortDescription'
      ),
      id: ORE_ESPORTS_TEMPLATES_TITLES.COUNTDOWN_ORE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-ore-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-ore-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-ore-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/countdown-ore-4.webp',
      ],
      title: i18n.t('screens.templates.ore.countdown.title'),
      tier: 'pro',
      users: 1777,
    },
    {
      category: i18n.t('screens.templates.medialoop.title'),
      description: i18n.t('screens.templates.ore.medialoop.description'),
      shortDescription: i18n.t(
        'screens.templates.ore.medialoop.shortDescription'
      ),
      id: ORE_ESPORTS_TEMPLATES_TITLES.MEDIALOOP_ORE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-ore-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-ore-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-ore-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/medialoop-ore-4.webp',
      ],
      title: i18n.t('screens.templates.ore.medialoop.title'),
      tier: 'pro',
      users: 347,
    },
    {
      category: i18n.t('screens.templates.controller.title'),
      description: i18n.t('screens.templates.ore.ps4ore.description'),
      shortDescription: i18n.t('screens.templates.ore.ps4ore.shortDescription'),
      id: ORE_ESPORTS_TEMPLATES_TITLES.CONTROLLER_PS4ORE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4ore-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4ore-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4ore-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps4ore-4.webp',
      ],
      title: i18n.t('screens.templates.ore.ps4ore.title'),
      tier: 'pro',
      users: 353,
    },
    {
      category: i18n.t('screens.templates.controller.title'),
      description: i18n.t('screens.templates.ore.ps5ore.description'),
      shortDescription: i18n.t('screens.templates.ore.ps5ore.shortDescription'),
      id: ORE_ESPORTS_TEMPLATES_TITLES.CONTROLLER_PS5ORE,
      images: [
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5ore-1.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5ore-2.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5ore-3.webp',
        'https://overlayon.s3.eu-west-3.amazonaws.com/controller-ps5ore-4.webp',
      ],
      title: i18n.t('screens.templates.ore.ps5ore.title'),
      tier: 'pro',
      users: 367,
    },
  ],
};

export default {
  ORE_ESPORTS_TEMPLATES,
  ORE_ESPORTS_TEMPLATES_IMAGES,
  ORE_ESPORTS_TEMPLATES_TITLES,
};
